import classNames from 'classnames';
import type { ReactNode } from 'react';
import React from 'react';
import { AnimatePresence } from 'framer-motion';
import { ignoreHoveredBlotLeaveClassName } from '../../HoveredBlotListener';
import styles from './FloatingToolbar.module.scss';
import ZoomInAnimation from '../../../components/ZoomInAnimation';

const NEAR_SIDE_HOVER_TOLERANCE = styles.nearSideHoverTolerance;

interface FloatingToolbarProps {
  bounds?: { top: number; right: number; left: number } | null;
  children: ReactNode;
  leftAligned?: boolean;
}

const FloatingToolbar = ({
  bounds,
  children,
  leftAligned,
}: FloatingToolbarProps) => (
  <AnimatePresence>
    {bounds && (
      <ZoomInAnimation
        data-no-print
        className={classNames(
          styles.hoverWrapper,
          ignoreHoveredBlotLeaveClassName,
          { [styles.leftAligned]: leftAligned },
        )}
        style={{
          top: bounds.top,
          left: leftAligned ? bounds.left : bounds.right,
        }}
        initial={{
          translateY: '-100%',
          translateX: leftAligned
            ? `-${NEAR_SIDE_HOVER_TOLERANCE}`
            : `calc(-100% + ${NEAR_SIDE_HOVER_TOLERANCE})`,
          transformOrigin: leftAligned
            ? `${NEAR_SIDE_HOVER_TOLERANCE} bottom`
            : `calc(100% - ${NEAR_SIDE_HOVER_TOLERANCE}) bottom`,
        }}
      >
        <div className={styles.container}>{children}</div>
      </ZoomInAnimation>
    )}
  </AnimatePresence>
);

export default FloatingToolbar;
